export default __webpack_public_path__ + "static/media/D23.ce70cbe0.webp";